export * from './ScanCardText';
